import { IconButton, Tooltip } from '@chakra-ui/react';
import { PAGE_MANAGER_OPENED } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ChevronIcon } from '../../../../assets/icons/chevron.svg';
import { selectIsSlideView } from '../../store/editorSettingsSelector';
import { toggleSlideView } from '../../store/editorSettingsSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

interface ToggleViewProps {
  left: string;
  buttonRef: React.RefObject<HTMLButtonElement>;
}
export const ToggleView = ({ left, buttonRef }: ToggleViewProps) => {
  const isSlideView = useAppSelector(selectIsSlideView);
  const { t } = useTranslation('editor_page_manager');
  const dispatch = useAppDispatch();

  const onToggleClick = () => {
    if (!isSlideView) {
      Mixpanel.track(PAGE_MANAGER_OPENED.eventName);
    }

    dispatch(toggleSlideView());
  };

  const label = isSlideView ? t('hide-all-pages') : t('show-all-pages');

  return (
    <Tooltip hasArrow placement='left' gutter={10} label={label} bg='black'>
      <IconButton
        ref={buttonRef}
        size='sm'
        py='12px'
        px='4px'
        position='absolute'
        top='40%'
        bg='white'
        left={left}
        onClick={onToggleClick}
        as='button'
        aria-label={label}
        borderTop='1px solid var(--vg-colors-gray-200)'
        borderLeft='1px solid var(--vg-colors-gray-200)'
        borderBottom='1px solid var(--vg-colors-gray-200)'
        icon={<ChevronIcon style={{ transform: isSlideView ? 'rotate(-90deg)' : 'rotate(90deg)' }} />}
      />
    </Tooltip>
  );
};
